module.exports = __webpack_public_path__ + "img/hands-bubbles.b086525d.svg";